
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/provisional-registration",
      function () {
        return require("private-next-pages/provisional-registration.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/provisional-registration"])
      });
    }
  